
import React from 'react';
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from "@/components/ui/carousel";
import { Card, CardContent } from "@/components/ui/card";

const testimonials = [
  {
    text: "The simulator provided invaluable hands-on experience in managing mining operations. I learned more in weeks than I did in months of theoretical study.",
    author: "Sarah Chen",
    role: "Mining Operations Manager"
  },
  {
    text: "An excellent tool for understanding the complexities of Bitcoin mining infrastructure. The real-world scenarios are incredibly helpful.",
    author: "Michael Rodriguez",
    role: "Infrastructure Specialist"
  },
  {
    text: "The progression system really helped me understand the career path in Bitcoin mining. It's both educational and engaging.",
    author: "David Park",
    role: "Energy Systems Engineer"
  }
];

const Testimonials = () => {
  return (
    <div className="w-full max-w-4xl mx-auto">
      <Carousel>
        <CarouselContent>
          {testimonials.map((testimonial, index) => (
            <CarouselItem key={index}>
              <Card className="bg-web3-blue/10 border border-web3-blue/20">
                <CardContent className="flex flex-col items-center justify-center p-6 text-center">
                  <p className="text-lg text-white/90 mb-4">"{testimonial.text}"</p>
                  <div className="mt-2">
                    <p className="font-semibold text-web3-green">{testimonial.author}</p>
                    <p className="text-sm text-white/80">{testimonial.role}</p>
                  </div>
                </CardContent>
              </Card>
            </CarouselItem>
          ))}
        </CarouselContent>
        <CarouselPrevious className="text-web3-green" />
        <CarouselNext className="text-web3-green" />
      </Carousel>
    </div>
  );
};

export default Testimonials;
